import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import AccessPicker from "./AccessPicker";
import decodeToken from "../../lib/decodeToken";
import { resolveHomeRoute } from "../../utils/resolveHomeRoute";

// Route wrapper for /select-access.
//
// Two entry points share it:
//   • straight after login, when more than one context exists
//   • the in-app switcher (?switch=1), which shows the list even if the user
//     currently has one option, because they explicitly asked to see it
//
// Landing is delegated to resolveHomeRoute, the same helper every other entry
// point uses, so the destination is decided by the REAL agent count in the newly
// selected account rather than by a stale role flag.
const SelectAccess = () => {
  const location = useLocation();
  const allowSingle = new URLSearchParams(location.search).get("switch") === "1";

  const handleResolved = useCallback(async () => {
    // Read the token AFTER the swap — the new context decides where home is.
    const decoded = decodeToken(localStorage.getItem("token") || "");
    localStorage.setItem("onboardComplete", "true");
    let path = await resolveHomeRoute(decoded);
    // Loop breaker. resolveHomeRoute sends unpicked multi-access sessions BACK
    // to /select-access; if the pick failed to stamp the token (a failed
    // switch-context, an offline getMyTeams) that would bounce this screen into
    // itself forever. Landing somewhere real is always better than a reload
    // loop — the picker stays reachable from the profile.
    if (path === "/select-access") path = "/fast-agent-detail";
    // Full load, not navigate(): ~23 components read the active context at mount
    // and apiStore captures the auth header at module load, so a soft transition
    // would leave half the app rendering the previous account.
    window.location.replace(path);
  }, []);

  return <AccessPicker onResolved={handleResolved} allowSingle={allowSingle} />;
};

export default SelectAccess;
